/*
    messaging.service.ts (WE SHOULD DEPRECATE THIS)
    This service provides methods for cross window and cross component communication.
*/
import {Injectable, EventEmitter, Output, Directive, ChangeDetectorRef} from '@angular/core';

declare var $: any;

@Directive()
@Injectable({
  providedIn: 'root'
})
export class MessagingService {
  /*
    **RESERVED EVENTS**

    parentClosing
    windowClosure
    parentBroadcast
    childBroadcast
  */

  socketProxy: any;
  socketIdentity: string;
  socketHostName: any;
  socketConnection: any;
  socketIsConnected: boolean = false;

  currentWindowUniqueId: any;
  popUpWindows: any = {};

  @Output() componentMessageCall: EventEmitter<any> = new EventEmitter();

  constructor(


  ) {}

  init() {

    window.addEventListener(
      'message',
      this.receivePopUpMessage.bind(this),
      false
    );
  }

  initSocketConnection() {

    this.socketHostName = location.origin;

    const signalRServerEndpoint = `${this.socketHostName}/notificationHub`;
    this.socketConnection = $.hubConnection(signalRServerEndpoint);
    this.socketProxy = this.socketConnection.createHubProxy('NotificationHub');

    this.socketProxy.on('RelayMessage', messagePayload => {
      if (messagePayload.senderIdentity !== this.socketIdentity) {
        const data = JSON.parse(messagePayload.data);
        this.broadCastMessage(messagePayload.eventName, data);
      }
    });

    this.socketProxy.on('SendIdentity', socketIdentity => {
      console.log('got socket identity', socketIdentity);
      this.socketIdentity = socketIdentity;
    });

    this.socketConnection.start()
    .done((data: any) => {
      this.socketIsConnected = true;
      this.joinSocketGroup();
    })
    .fail((error: any) => {
      this.socketIsConnected = false;
    });
  }

  joinSocketGroup() {
    if (!this.socketIsConnected) {
      return;
    }
    console.log('joining group', this.socketHostName);
    this.socketProxy.invoke('JoinGroup', this.socketHostName)
      .done((data: any) => { })
      .catch((error: any) => { });
  }

  sendSocketMessage(event: string, data: any) {
    if (!this.socketIsConnected) {
      return;
    }
    const dataString = JSON.stringify(data);
    const payload = {
      senderIdentity: this.socketIdentity,
      hostName: this.socketHostName,
      eventName: event,
      data: dataString,
    };
    this.socketProxy.invoke('RelayMessage', payload)
    .done((data: any) => {})
    .catch((error: any) => {});
  }

  // only sends a broadcast to any pop-up and component from this window
  broadCastMessage(event: string, data: any) {
    console.log("broadCastMessage event", event);
    console.log("broadCastMessage data", data);
    this.sendComponentMessage(event, data);
    this.broadCastPopUpMessage(event, data);
  }

  // sends a broadcast to all pop-ups and components current opened
  recursiveBroadCastMessage(event: string, data: any) {
    const dataObj = {
      event,
      data
    };
    if (this.currentWindowUniqueId) {
      // dataObj.uniqueWindowId = this.currentWindowUniqueId;
      this.sendParentMessage('parentBroadcast', dataObj);
    } else {
      this.broadCastPopUpMessage('childBroadcast', dataObj);
    }
    this.sendComponentMessage(event, data);
  }

  // sends a broadcast to any pop-up opened from this window
  broadCastPopUpMessage(event: string, data: any) {
    for (const i in this.popUpWindows) {
      const currentPopUpId = i;
      this.sendPopUpMessage(event, data, currentPopUpId);
    }
  }

  // sends a message to the window that created this child window
  sendParentMessage(event: string, data: any) {
    console.log("sendParentMessage event", event);
    console.log("sendParentMessage data", data);
    console.log("sendParentMessage opener", window.opener);
    const returnData = {
      event,
      data
    };
    if (window.opener)
      window.opener.postMessage(JSON.stringify(returnData), null);
  }

  // sends a message to all components within this window
  sendComponentMessage(event: string, data: any) {
    //console.log("sendComponentMessage: ", event, data);
    const dataObject = {
      event,
      data
    };
    this.componentMessageCall.emit(dataObject);
  }

  // sends a message to all children of this window and alerts them that their parent is closing
  alertChildrenOnClosure() {
    for (const i in this.popUpWindows) {
      const currentPopUpId = i;
      this.sendPopUpMessage('parentClosing', {}, currentPopUpId);
    }
  }

  // sends a message to the parent of this window and alerts it that the child with a unique id is closing
  alertOpenerOnClosure() {
    const data = {
      event: 'windowClosure',
      data: { windowId: this.currentWindowUniqueId }
    };
    this.recursiveBroadCastMessage(data.event, data.data);
    // window.opener.postMessage(JSON.stringify(data));
  }

  // sends a message to a specific pop-up window
  sendPopUpMessage(event: string, data: any, uniqueWindowId: string) {
    if (this.popUpWindows[uniqueWindowId]) {
      const dataObject = {
        event,
        data
      };
      try {
        this.popUpWindows[uniqueWindowId].postMessage(
          JSON.stringify(dataObject)
        );
      } catch (e) {
        console.log(e);
      }
    } else {
      console.log('no window with that id found');
    }
  }

  openPopUpWindow(
    url: string,
    optionString: string,
    dataName: string,
    data: any,
    postClosureData: any,
    fullURL: boolean = false,
    windowName: string = '_blank'
  ) {
    try {
      const uniqueWindowId = this.generateUID();
      const newOpenedWindow = window.open(url, windowName, optionString);
      // newOpenedWindow.uniqueWindowId = uniqueWindowId;
      // newOpenedWindow.postClosureData = postClosureData;
      newOpenedWindow[dataName] = JSON.stringify(data);
      this.popUpWindows[uniqueWindowId] = newOpenedWindow;
      return uniqueWindowId;
    } catch (e) {
      return null;
    }
  }

  private generateUID() {
    let firstPart: any = (Math.random() * 46656) | 0;
    let secondPart: any = (Math.random() * 46656) | 0;
    firstPart = ('000' + firstPart.toString(36)).slice(-3);
    secondPart = ('000' + secondPart.toString(36)).slice(-3);
    return firstPart + secondPart;
  }

  private receivePopUpMessage(event: any) {
    try {
      const data = JSON.parse(event.data);
      if (data.event && data.event === 'parentClosing') {
        window.close();
      } else if (data.event && data.event === 'windowClosure') {
        const closingPopUp = this.popUpWindows[data.data.windowId];
        const postClosureData = closingPopUp.postClosureData;
        for (let i = 0; i < postClosureData.length; i++) {
          const currentClosureData = postClosureData[i];
          this.sendComponentMessage(
            currentClosureData.event,
            currentClosureData.data
          );
        }
      } else if (data.event && data.event == 'parentBroadcast') {
        if (this.currentWindowUniqueId) {
          this.sendParentMessage('parentBroadcast', data.data);
        } else {
          this.sendComponentMessage(data.data.event, data.data.data);
          this.broadCastPopUpMessage('childBroadcast', data.data);
        }
      } else if (data.event && data.event == 'childBroadcast') {
        this.sendComponentMessage(data.data.event, data.data.data);
        this.broadCastPopUpMessage('childBroadcast', data.data);
      } else if (data.event && data.data) {
        this.sendComponentMessage(data.event, data.data);
      }
    } catch (e) {
      // this means that there was no json data sent in the message
    }
  }
}
